import { FC } from 'react';

import { Title } from '../../UI/title/Title';
import Wrapper from '../../UI/wrapper/Wrapper';
import DarkMode from '../../darkMode/DarkMode';
import DemoBlock from '../../demoBlock/DemoBlock';
import FontsBlock from '../../fontsBlock/FontsBlock';
import LogoBlock from '../../logoBlock/LogoBlock';
import Palette from '../../palette/Palette';

import styles from './DesignSection.module.scss';

type TDesign = {
    features: string[];
    demos: number;
};

const DesignSection: FC<TDesign> = ({ demos }) => {
    const heading = 'Tailored Features for Peak Performance';
    const excerpt =
        'Discover powerful design features and elements that will help you scale your content.';

    return (
        <section className={styles.design__section}>
            <Wrapper>
                <Title text={heading} size="lg" className={styles.heading} />
                <p className={`excerpt body-lg excerpt-wrap ${styles.excerpt} `}>{excerpt}</p>

                <div className={styles.features__wrapper}>
                    <DarkMode />
                    <DemoBlock demos={demos} />
                    <Palette />
                    <FontsBlock />
                    <LogoBlock />
                </div>
            </Wrapper>
        </section>
    );
};

export default DesignSection;
